import React from "react";
import LogoGlosari from "../../../assets/background/logo/logoGlosari.png";
import { useTheme } from "@mui/material/styles";

export default function FormHeader({ title }) {
  const theme = useTheme();
  return (
    <div className="flex items-center gap-4 justify-center">
      <img
        src={LogoGlosari}
        style={{ width: "280px", height: "auto", objectFit: "contain" }}
      />
      <div
        className="text-[24px] font-bold font-inter"
        style={{ color: theme.palette.primary.main }}
      >
        {title}
      </div>
    </div>
  );
}
